import { render } from "./CustomConfirmModal.vue?vue&type=template&id=5c76e302"
import script from "./CustomConfirmModal.vue?vue&type=script&lang=js"
export * from "./CustomConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__